import React, { ComponentProps } from 'react';
import { BaseButton, Icon } from '@common/components';

type BaseProps = ComponentProps<typeof BaseButton>;

export const AttachmentButton = ({
  children,
  type = 'default',
  ...props
}: Omit<BaseProps, 'icon'>) => (
  <BaseButton {...props} type={type} icon={<Icon icon="paperclip" />}>
    {children}
  </BaseButton>
);
